export function FlashUtilScript_getTimer(sec) {
    return Date.now() - sec.flash.display.Loader.axClass.runtimeStartTime;
}
